import script from "./individual-category-group.vue?vue&type=script&lang=ts&setup=true"
export * from "./individual-category-group.vue?vue&type=script&lang=ts&setup=true"

import "./individual-category-group.vue?vue&type=style&index=0&id=124f0816&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124f0816"]])

export default __exports__